import React from 'react';
import { connect } from 'react-redux';
import { Select, Button, Spin } from 'antd';
import UpdateICConfigWrapper from './UpdateICConfig.style';
import PrimaryForm from '../PrimaryForm/PrimaryForm';
import SecondaryForm from '../SecondaryForm/SecondaryForm';
import { getConfigList, setIcToUpdate, changeIcToUpdate, setSelectedValues, updateStep } from '../../../redux/actions/IC/ICActions';

const Option = Select.Option;

class UpdateICConfig extends React.Component {
  
  constructor() {
    super();
    this.changeIcToUpdate = this.changeIcToUpdate.bind(this);
    this.handleIcToUpdate = this.handleIcToUpdate.bind(this);
  }

  componentDidMount() {
    this.props.getConfigList();
    this.props.changeIcToUpdate("");
    this.props.updateStep(1);
    this.props.setSelectedValues({});
  }

  handleIcToUpdate() {
    this.props.setIcToUpdate(this.props.ICREDUCER.ic_to_update);
  }

  changeIcToUpdate(value) {
    this.props.changeIcToUpdate(value);
  }
  
  render() {

    const icList = this.props.ICREDUCER.configList.map((ic,i) => <Option key={i} value={ic.ic_code}>{ic.name}</Option>);

    let update_ic_view;

    if(this.props.ICREDUCER.ic_to_update === "" || (this.props.ICREDUCER.ic_to_update !== this.props.ICREDUCER.selectedValues.ic_code) ) {
      update_ic_view = <UpdateICConfigWrapper>
      <h3>Select an IC to update</h3>
      <Select showSearch notFoundContent={!this.props.configList ? <Spin size="small" /> : null} placeholder="Select IC" onChange={this.changeIcToUpdate} style={{ width: '50%' }}>
        {icList}
      </Select>
      <Button type="primary" onClick={this.handleIcToUpdate} className="submit-ic-code" >Submit</Button>
    </UpdateICConfigWrapper>
    }
    else {
      if(this.props.ICREDUCER.update_step === 1) {
        update_ic_view = <PrimaryForm from="update" />
      }
      else {
        update_ic_view = <SecondaryForm from="update" />
      }
    }

    return(
      update_ic_view
    );
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  getConfigList,
  changeIcToUpdate,
  setIcToUpdate,
  setSelectedValues,
  updateStep
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateICConfig);


// WEBPACK FOOTER //
// ./src/components/IC/UpdateICConfig/UpdateICConfig.js